export default "__VITE_ASSET__BREXezew__"